import { useEffect } from 'react'
import { useUser } from '../contexts/UserContext'

// The Perch feedback widget injects its own floating "Report an issue" /
// create-ticket button (bottom-right) that files tickets. It replaced the old
// admin-only Linear bug-report button, but as a static <script> in index.html
// it rendered for every visitor. This restores the original gating: the widget
// only loads for admins.
//
// We load the third-party script imperatively (instead of the index.html tag)
// so we can key it on the signed-in user's role, which isn't known until the
// profile resolves. Role can flip without a full page reload (SPA login /
// logout), so we also tear the widget back down when the user is not an admin.
const PERCH_SRC = 'https://perch.shortbird.dev/perch.js'
const PERCH_KEY = '4dbef77c-615b-4388-a672-7d6699c7f86c'
const PERCH_SCRIPT_ID = 'perch-widget-script'

// Best-effort removal of anything the widget injected into the DOM, so an admin
// who signs out (SPA navigation, no reload) doesn't keep the button.
function removePerchWidget() {
  document.getElementById(PERCH_SCRIPT_ID)?.remove()
  document
    .querySelectorAll('[id*="perch" i], [class*="perch" i], [data-perch]')
    .forEach((el) => el.remove())
}

export default function PerchWidget() {
  const { user } = useUser()
  const isAdmin = user?.role === 'admin'

  useEffect(() => {
    if (!isAdmin) {
      removePerchWidget()
      return
    }

    // Already loaded (e.g. re-render) — leave the existing widget in place.
    if (document.getElementById(PERCH_SCRIPT_ID)) return

    const script = document.createElement('script')
    script.id = PERCH_SCRIPT_ID
    script.src = PERCH_SRC
    script.dataset.key = PERCH_KEY
    script.dataset.position = 'bottom-left'
    script.defer = true
    document.body.appendChild(script)
  }, [isAdmin])

  return null
}
